module.exports = __webpack_public_path__ + "static/media/workshops.cb4a095e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/workshops.jpg
// module id = 564
// module chunks = 0